// Who a policy converted from an offer is written for — the prefill of the
// Convert to Policy form.
//
// NO React or Redux imports: backend/tests/convertPolicyholderPrefill.test.mjs
// loads this file directly in Node.
//
// Same answer as policyholderFromOffer() in backend/services/offerIdentity.js,
// which the server applies again on create.
import { nameCandidate } from '../../utils/legalForm.js';

/**
 * `{ name, company }` for the form, from any of the shapes offers use
 * (PGMA/RC Pro have first+last, PGM and RC Pro a contactName, IJM/E&O/PJ
 * only the top-level client string).
 *
 * `company` ("Entreprise / Cabinet") is the practice or company NAME, or ''.
 * It used to be the raw `companyName`, so an RC Pro sole proprietor whose
 * offer answered that field "Raison individuelle" (QT-2026-0117) had the
 * legal form prefilled as the practice. Every candidate goes through
 * nameCandidate, which also drops the "—" the offers list renders for a
 * missing client.
 */
export function policyholderPrefill(offer) {
  const ph = offer?.params?.policyholder || {};
  const company = nameCandidate(ph.companyName);
  const person = nameCandidate([ph.firstName, ph.lastName].filter(Boolean).join(' ').trim());
  const name = person
    || nameCandidate(ph.contactName)
    || company
    || nameCandidate(offer?.client);
  return { name, company };
}
